import React, { FC } from 'react'
import { PASSWORD_PATTERNS } from '@mortgage-pos/ui/utils/createValidationSchema'

const { CHARACTER_LENGTH, UPPERCASE, LOWERCASE, NUMBER, SPECIAL_CHARACTER } =
  PASSWORD_PATTERNS

export const REQUIREMENTS = {
  CHARACTER_LENGTH: {
    regex: new RegExp(`.${CHARACTER_LENGTH}`),
    text: 'At least 8 characters long',
  },
  UPPERCASE: { regex: new RegExp(`${UPPERCASE}`), text: '1 uppercase letter' },
  LOWERCASE: { regex: new RegExp(`${LOWERCASE}`), text: '1 lowercase letter' },
  NUMBER: { regex: new RegExp(`${NUMBER}`), text: '1 number' },
  SPECIAL_CHARACTER: {
    regex: new RegExp(`${SPECIAL_CHARACTER}`),
    text: '1 special character',
  },
}

type PasswordRequirementsProps = {
  password: string
}

export const PasswordRequirements: FC<PasswordRequirementsProps> = ({
  password,
}) => (
  <div className="password-requirements" data-testid="password-requirements">
    <p className="password-requirements__title">
      Please enter a password with the following criteria:
    </p>
    <ul className="password-requirements__list">
      {Object.entries(REQUIREMENTS).map(([key, requirement]) => {
        const matches = requirement.regex.test(password)
        return (
          <li
            className={`requirement-list-item ${matches ? '--matches' : ''}`}
            data-testid={key}
            key={key}
          >
            <span className="requirement-list-item__image-container">
              <img
                className="requirement-list-item__image"
                src="/assets/check-mark.svg"
                alt="Check mark icon"
              />
            </span>
            <p className="requirement-list-item__text">{requirement.text}</p>
          </li>
        )
      })}
    </ul>
  </div>
)
